import classNames from 'classnames';
import { IconBell } from 'featherico';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import Button from '../../Button';
import NotificationsCount from '../NotificationsCount';
import NotificationsDropdown from '../NotificationsDropdown';

import styles from './style.m.less';

const propTypes = {
    showDropdown: PropTypes.bool.isRequired,
    actions: PropTypes.shape({
        doShowNotificationsDropdown: PropTypes.func.isRequired,
    }),
    count: PropTypes.number,
};

function NotificationsTrigger(props) {
    const nodeRef = useRef();
    const { showDropdown, actions } = props;

    useEffect(() => {
        if (!showDropdown) {
            return;
        }
        const handleDocumentClick = event => {
            if (nodeRef.current && !nodeRef.current.contains(event.target)) {
                actions.doShowNotificationsDropdown(false);
            }
        };
        const handleEscapeHit = event => {
            if (event.keyCode === 27) {
                actions.doShowNotificationsDropdown(false);
            }
        };
        document.addEventListener('click', handleDocumentClick);
        document.addEventListener('keyup', handleEscapeHit);
        return () => {
            document.removeEventListener('click', handleDocumentClick);
            document.removeEventListener('keyup', handleEscapeHit);
        };
    }, [actions, showDropdown]);

    return (
        <span className={styles.container} ref={nodeRef}>
            <NotificationsTriggerButton {...props} onClick={() => actions.doShowNotificationsDropdown(!showDropdown)} />
            {showDropdown ? (
                <NotificationsDropdown onCloseClick={() => actions.doShowNotificationsDropdown(false)} />
            ) : null}
        </span>
    );
}

NotificationsTrigger.propTypes = propTypes;

function NotificationsTriggerButton({ onClick, hasAlert, showDropdown, count }) {
    const buttonClasses = classNames('headerIconButton', styles.button, {
        [styles.has_count]: hasAlert,
        [styles.dropdown_visible]: showDropdown,
    });
    return (
        <Button
            kind="PLAIN"
            onClick={onClick}
            className={buttonClasses}
            aria-label="Notifications"
            aria-haspopup="true"
            aria-expanded={showDropdown}
            eventTracking={{ category: 'navigation header', action: 'click bell', value: count }}
        >
            <IconBell className={styles.bell} />
            <NotificationsCount />
        </Button>
    );
}

export default NotificationsTrigger;
